import { render } from "./user_tags.vue?vue&type=template&id=66dcbcbe&scoped=true&ts=true"
import script from "./user_tags.vue?vue&type=script&lang=ts"
export * from "./user_tags.vue?vue&type=script&lang=ts"

import "./user_tags.vue?vue&type=style&index=0&id=66dcbcbe&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dcbcbe"]])

export default __exports__